<mat-form-field class="w-100">
  <mat-label>Search...</mat-label>
  <input type="text" matInput [(ngModel)]="value">
</mat-form-field>
